export default "__VITE_ASSET__DXG8RHWU__"